import * as t from "io-ts"

export const User = t.type({
    group: t.string,
    username: t.string,
    name: t.string,
    initials: t.string,
})

export const Users = t.array(User)

export type IUsersType = t.TypeOf<typeof Users>

export type ISingleUserType = t.TypeOf<typeof User>
